import * as React from 'react';

import FileZip32 from './FileZip32';

export const fileZip32 = () => <FileZip32 />;

export default {
    title: 'Icon/Content/FileZip32',
    component: FileZip32,
    parameters: {
        notes: "`import FileZip32 from 'box-ui-elements/es/icon/content/FileZip32';`",
    },
};
